<template>
  <el-dialog :title="$t('crm.upload.title')" :visible.sync="visible" width="50%" @close="handleClose">
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px" class="text-left">
      <el-form-item :label="$t('crm.upload.community')" prop="communityId">
        <el-select
          v-model="formData.communityId"
          filterable
          :placeholder="$t('crm.upload.communityPlaceholder')"
          style="width:100%"
          @change="handleCommunityChange"
        >
          <el-option
            v-for="item in communityList"
            :key="item.communityId"
            :label="item.name"
            :value="item.communityId"
          />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('crm.upload.owner')" prop="appUserId">
        <el-select
          v-model="formData.appUserId"
          filterable
          :placeholder="$t('crm.upload.ownerPlaceholder')"
          style="width:100%"
          :disabled="!formData.communityId"
          @change="handleOwnerChange"
        >
          <el-option
            v-for="item in ownerList"
            :key="item.appUserId"
            :label="item.appUserName + (item.link ? ' (' + item.link + ')' : '')"
            :value="item.appUserId"
          />
        </el-select>
      </el-form-item>

      <el-form-item v-if="selectedOwner" :label="$t('crm.upload.ownerInfo')">
        <div class="owner-info-box">
          <span>{{ $t('crm.upload.ownerName') }}：{{ selectedOwner.appUserName }}</span>
          <span>{{ $t('crm.upload.ownerLink') }}：{{ selectedOwner.link || '-' }}</span>
        </div>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">
        {{ $t('crm.upload.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { listAdminCommunitys, listAdminAppUserOwners } from '@/api/owner/adminAuthOwnerApi'
import { uploadOwnerToCrm } from '@/api/crm/crmUploadApi'

export default {
  name: 'UploadOwnerToCrm',
  data() {
    return {
      visible: false,
      submitting: false,
      communityList: [],
      ownerList: [],
      selectedOwner: null,
      formData: {
        communityId: '',
        communityName: '',
        appUserId: '',
        ownerId: '',
        ownerName: '',
        link: '',
        userId: ''
      },
      rules: {
        communityId: [
          { required: true, message: this.$t('crm.validate.communityRequired'), trigger: 'change' }
        ],
        appUserId: [
          { required: true, message: this.$t('crm.validate.ownerRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.visible = true
      this.resetForm()
      this.getCommunityList()
    },
    handleClose() {
      this.resetForm()
    },
    resetForm() {
      this.formData = {
        communityId: '',
        communityName: '',
        appUserId: '',
        ownerId: '',
        ownerName: '',
        link: '',
        userId: ''
      }
      this.ownerList = []
      this.selectedOwner = null
    },
    async getCommunityList() {
      try {
        const { data } = await listAdminCommunitys({ page: 1, row: 100 })
        this.communityList = data || []
      } catch (error) {
        this.$message.error(this.$t('crm.upload.communityLoadError'))
      }
    },
    async handleCommunityChange(communityId) {
      this.formData.appUserId = ''
      this.formData.ownerId = ''
      this.formData.userId = ''
      this.selectedOwner = null
      this.ownerList = []
      const community = this.communityList.find(item => item.communityId === communityId)
      this.formData.communityName = community ? community.name : ''
      if (!communityId) {
        return
      }
      try {
        const { data } = await listAdminAppUserOwners({ page: 1, row: 100, communityId: communityId })
        this.ownerList = data || []
      } catch (error) {
        this.$message.error(this.$t('crm.upload.ownerLoadError'))
      }
    },
    handleOwnerChange(appUserId) {
      // 用 owner_app_user 主键 appUserId 匹配（唯一），避免 ownerId 重复/错位导致选中记录张冠李戴
      this.selectedOwner = this.ownerList.find(item => item.appUserId === appUserId)
      if (this.selectedOwner) {
        this.formData.ownerId = this.selectedOwner.ownerId || ''
        this.formData.userId = this.selectedOwner.userId || ''
        this.formData.ownerName = this.selectedOwner.appUserName
        this.formData.link = this.selectedOwner.link || ''
      } else {
        this.formData.ownerId = ''
        this.formData.userId = ''
        this.formData.ownerName = ''
        this.formData.link = ''
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return
        }
        this.submitting = true
        try {
          await uploadOwnerToCrm(this.formData)
          this.$message.success(this.$t('crm.upload.success'))
          this.visible = false
          this.$emit('success')
        } catch (error) {
          this.$message.error(error.message || this.$t('crm.upload.error'))
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.owner-info-box {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 10px 15px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 14px;
  color: #606266;
}
</style>